export enum IdentityProvider {
    Facebook = 'facebook',
    Google = 'google',
}
